import { Routes } from '@angular/router';
import { GermplasmNameAuditPopupComponent } from './germplasm-name-audit.component';

export const GERMPLASM_NAME_AUDIT_ROUTES: Routes = [
    {
        path: 'germplasm/:gid/names/:nameId/audit-dialog',
        component: GermplasmNameAuditPopupComponent,
        outlet: 'popup'
    }
];
